import {FavoriteCategory, TrainingCategory} from '@/components/types';

export type TrainingStatusAPIData = {
  id: string;
  safetyEducationIndex: number;
  month: string;
  detail: string;
  total: number;
  done: number;
  url: string;
  created: string;
  deadline: string;
  isActive: boolean;
  tags: TrainingCategory[];
};

export type TrainingCategoryAPIData = {
  trainingCategories: TrainingCategory[];
};

export type GroupFavoriteCategoryAPIData = {
  favoriteCategories: FavoriteCategory[];
};

export type TrainingStatusVueData = {
  val: number;
  done: number;
  total: number;
  summary: string;
  targetMonth: string;
  color: StatusBarColor;
  url: string;
};

export type StatusBarColor = 'green' | 'yellow' | 'red';
export type ProgressCircle = 'grey' | 'blue lighten-1';

export interface TraineeStatus {
  mark: {
    icon: string;
    color: string;
  };
}

export type TraineeMarks = 'error_outline' | 'check_circle';
export type AuditMarks =
  | 'priority_high'
  | 'warning'
  | 'check_circle_outline'
  | 'check_circle';

export type LoginFormData = {
  email: string;
  password: string;
};

export type MonthTrainingStatusParUser = {
  month: string;
  detail: string;
  total: number;
  done: number;
  createAt: string;
  users: Array<Trainee>;
};

export type ContractReq = {
  startDate: string;
  endDate: string;
  threshold: number;
};

export type ContractChartRes = {
  runtimes: Array<TraineeRuntime>;
  startDate: string;
  endDate: string;
  branchOfficeID: string;
  branchOfficeName: string;
};

export type TraineeRuntime = {
  traineeID: string;
  traineeName: string;
  traineeFurigana: string;
  totalRuntime: number;
};

export type YearInfo = {
  start: string;
  end: string;
  dates: Dates;
};

export type Dates = {
  baseDeadline: string;
  display: string;
  fiscalYearStart: string;
};

export type GroupRes = {
  companyName: string;
  companyJName?: string;
  companyID: string;
  scope: string;
  currentYear: number;
  fiscalStartMonthDate: string;
};

export type Trainee = {
  id: string;
  name: string;
  kana: string;
  attr: string;
  lastUpdate: string;
  status: 'doing' | 'done';
};

export type TraineeVueData = {
  id: string;
  name: string;
  done: '未完了' | '完　了';
  color: 'red' | 'green';
};

export type DemoVideo = {
  title: string;
  description: string;
  path: string;
};

export type ChatAPIData = {
  header: ChatHeader[];
  rows: string[][];
};

export type ChatHeader = {
  safetyEducationIndex: number;
  title: string;
  deadline: string;
  isActive: boolean;
  tags: TrainingCategory[];
};

export type ChatByIDAPIData = {
  safetyEducationIndex: number;
  detail: string;
  deadline: string;
  total: number;
  done: number;
  progress: number;
  url: string;
  users: Array<Trainee>;
};

export enum ChartSortTrainings {
  // ID の 数字 の 昇順
  Default,
  // DLD の 昇順
  DLD,
  // ID の 文字 の 昇順
  IDChar,
}

export enum ChartOutputType {
  Default,
  HistoryCount,
  TotalHistoryCount,
}
